// Confirm dialog wrapper around generic Modal — used for destructive bulk actions
// (Q10 — DESIGN-DECISIONS-2026-05-01).

import type { JSX, ReactNode } from "react";
import { Modal } from "./Modal.js";

interface Props {
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmDialog(props: Props): JSX.Element {
  const {
    title, message, confirmLabel = "Confirm", cancelLabel = "Cancel",
    destructive = false, busy = false, onConfirm, onClose,
  } = props;
  const confirmCls = destructive
    ? "bg-red-600 hover:bg-red-700"
    : "bg-navy-700 hover:bg-navy-800";
  return (
    <Modal title={title} onClose={onClose}>
      <div className="text-sm text-slate-700 space-y-3">{message}</div>
      <div className="flex justify-end gap-2 pt-4">
        <button
          type="button"
          onClick={onClose}
          disabled={busy}
          className="px-4 py-2 text-sm rounded-lg bg-slate-100 text-slate-700 hover:bg-slate-200 disabled:opacity-50"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className={`px-4 py-2 text-sm rounded-lg text-white font-medium transition-colors disabled:opacity-50 ${confirmCls}`}
        >
          {busy ? "Working…" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
